import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcClockIcon, IcDoneIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import { useScheduleButtonPresenter } from './ScheduleButton.presenter';
import styles from './ScheduleButton.style.m.css';

interface IScheduleButtonProps {
  className?: string;
}

export const ScheduleButton: FC<IScheduleButtonProps> = observer(({ className }) => {
  const presenter = useScheduleButtonPresenter();

  return (
    <div className={className}>
      <FAB
        size={'30'}
        className={styles.button}
        onClick={presenter.onSubmit}
        Icon={presenter.isEditMode ? IcDoneIcon : IcClockIcon}
        theme={'14'}
        isDisabled={presenter.isDisabled}
        dataTest="send-message-button"
      />
    </div>
  );
});
